import {useParams} from "react-router-dom";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import {useEffect, useState} from "react";
import api from "../../api";
import {BlogData} from "../types/Page";


import '../../styles/Blog.scss';
import {IMAGE_URL} from "../../path";
import {BlogComponent} from '../types/Page';

function IndividualBlog() {
    const { slug } = useParams();
    const [blogData, setBlogData] = useState<BlogData | null>(null);

    async function fetchBlog() {
        try {
            const res = await api.get(`/v1/blog/${slug}`);
            console.log(res);
            setBlogData(res.data);
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        fetchBlog()
    }, [slug]);

    // export interface BlogComponent {
    //     type: string;
    //     body?: string;
    //     image?: string;
    // }
    //
    function getComponent(component: BlogComponent) {
        if (component.type === "body") {
            if (typeof component.body === "string") {
                return (
                    <div className="body-component" dangerouslySetInnerHTML={{ __html: component.body }} />
                )
            }
        }
        else if (component.type === "image") {
            if (typeof component.image === "string") {
                return (
                    <img src={`${IMAGE_URL}/${component.image}`} alt={component.image} />
            )
            }
        }

        return <div></div>
    }

    return (
        <div>
            <Header />
            <div className="individual-blog-main">
                {blogData && blogData.blog && (
                    <div className="blog-inner">
                        <div className="blog-hero">
                            <img src={`${IMAGE_URL}/${blogData.blog.hero_image}`} alt={blogData.blog.title} />
                        </div>
                        <div className="blog-main">
                            <div className="blog-header">
                                <div className="title">
                                    <div className="time">
                                        {blogData.blog.read_time} min read
                                    </div>
                                    <div className="category">
                                        {blogData.blog.category.name}
                                    </div>
                                </div>
                                <h3>{blogData.blog.title}</h3>
                                <div className="subtitle">
                                    {blogData.blog.subtitle}
                                </div>
                            </div>
                            <div className="blog-content">
                                {blogData.blog.components && blogData.blog.components?.map((component, index) => (
                                    getComponent(component)
                                ))}
                            </div>
                        </div>

                    </div>
                )}
            </div>
            <Footer />
        </div>
    )
}

export default IndividualBlog;
